import { ReactNode } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  /** Extra classes for the dialog content panel. */
  className?: string;
}

/**
 * Centered modal — uses the same Radix Dialog as BuyCreditsDialog so it
 * always floats above the bottom navigation and browser toolbars and shares
 * one consistent scroll model (single panel, capped at 90vh).
 */
export const BottomSheet = ({ open, onClose, title, children, className }: BottomSheetProps) => {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className={cn("sm:max-w-sm max-h-[90vh] overflow-y-auto overscroll-contain", className)}
      >
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};
